import { render, staticRenderFns } from "./NamespaceRank.vue?vue&type=template&id=1d684771&scoped=true&"
import script from "./NamespaceRank.vue?vue&type=script&lang=js&"
export * from "./NamespaceRank.vue?vue&type=script&lang=js&"
import style0 from "./NamespaceRank.vue?vue&type=style&index=0&id=1d684771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d684771",
  null
  
)

export default component.exports